export default "__VITE_ASSET__ca37ecfe__"